'use strict';

import {
    newModalFromSelector
} from '../components/modal';

import sizePanel from './sizePanel';

// Checks if size is selected before adding to wishlist
function isSizeSelected () {
    if ($('.page-checkout').length > 0 || $('.cart-page').length > 0) {
        return true;
    }
    if ($('.form-control.pdp-size-box.checkbox-size').length > 0 || $('.form-control.pdp-size-box.checkbox-quickview-mobile').length > 0) {
        return ($('.form-control.pdp-size-box.checkbox-size input:checked').length > 0 || $('.form-control.pdp-size-box.checkbox-quickview-mobile input:checked').length > 0);
    } else {
        return $('[data-attr="size"] input:checked').length > 0;
    }
};


/**
 * Adapts FE to the current state of the wishlist:
 *  - Add / Remove the `added` class to the correct target (either button or icon)
 *  - Shows the "correctly added" / "correctly removed" notification
 *  - Triggers ADD event for analytics
 *  - Add/remove the PID from the ID in page to always have the correct state
 *      (updateWishlistInternalState)
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to toggle a product to the wishlist
 * @param {boolean} isAddAction - if the te action was add or remove
 */
function displayMessageAndChangeIcon (data, icon, isAddAction) {
    if (data.success) {
        $('body').trigger('wishlist:update', data.wishlistTotal);

        if (icon) {
            if (isAddAction) {
                if ($('.page').data('action') === 'Product-Show' && $('.js-pdpStickyBar').length > 0) {
                    $('.wishlist-icon').addClass('added');
                    $('.wishlist-icon').find('use').attr('href', icon.data('full-heart'));
                } else {
                    icon.addClass('added');
                    icon.find('use').attr('href', icon.data('full-heart'));
                }
                let sender = icon.data('analytics-sender') ? icon.data('analytics-sender') : '';
                $('body').trigger('wishlist:add', { sku: data.pid, sender: sender });
            } else {
                if ($('.page').data('action') === 'Product-Show' && $('.js-pdpStickyBar').length > 0) {
                    $('.wishlist-icon').removeClass('added');
                    $('.wishlist-icon').find('use').attr('href', icon.data('empty-heart'));
                } else {
                    icon.removeClass('added');
                    icon.find('use').attr('href', icon.data('empty-heart'));
                }
            }
            updateAriaLabelForWishlistLink($('.wishlist-icon'));
            icon.blur();
        }

        showWishlistNotification(data.renderedTemplate);

        updateWishlistInternalState(data.pid, isAddAction);
    }
}

function showWishlistNotification (html) {
    $('body').append(html);
    let offsetTop = 12;
    if (Foundation.MediaQuery.atLeast('large')) {
        offsetTop = $('.js-mainHeader').outerHeight() + 10;
    }
    $('.js-add-to-wishlist-notification').css({
        top: offsetTop
    });

    function closeNotification () {
        $('.js-add-to-wishlist-notification').off('click', '.js-close-notification');
        $('.js-add-to-wishlist-notification').remove();
    }

    $('.js-add-to-wishlist-notification').on('click', '.js-close-notification', closeNotification);

    setTimeout(closeNotification, 5000);
}

/**
 * Updates the internal state of the wishlist with the new item:
 *  - adds the item in the state if the item was added
 *  - removes the item if the item was removed
 * @param {string} pid - The PID of the product changed in the wishlist
 * @param {boolean} isAddAction - true if the item has been added, false is it has been removed
 */
function updateWishlistInternalState (pid, isAddAction) {
    /** @type {Array.<string>} */
    let oldItems = $('#wishlistItems').val().split(',');
    let newItems;
    if (isAddAction) {
        oldItems.push(pid);
        newItems = oldItems.join(',');
    } else {
        let oldIdx = oldItems.indexOf(pid);
        if (oldIdx > -1) {
            oldItems.splice(oldIdx, 1);
            newItems = oldItems.join(',');
        }
    }
    $('#wishlistItems').val(newItems);
};

function addDefinitelyToWishlist (sender, productID, e) {
    // If productID is set then it means that it belongs to an unavailable size
    // Add or remove from wishlist now!

    var btn = sender;
    var addURL = btn.data('href');
    var removeURL = btn.data('remove');

    let pid = '';
    if (productID === null) {
        pid = $('.product-detail-keeper').attr('data-variant-pid');
    } else {
        pid = productID;
    }
    var optionId = btn.closest('.product-detail-keeper').find('.product-option').attr('data-option-id');
    var optionVal = btn.closest('.product-detail-keeper').find('.options-select option:selected').attr('data-value-id');
    optionId = optionId || null;
    optionVal = optionVal || null;

    var shouldAdd = !btn.hasClass('added');

    if (!(addURL && removeURL) || !pid) {
        return;
    }

    $.spinner().start();
    $.ajax({
        url: shouldAdd ? addURL : removeURL,
        type: shouldAdd ? 'post' : 'get',
        dataType: 'json',
        data: {
            pid: pid,
            optionId: optionId,
            optionVal: optionVal
        },
        success: function (data) {
            // if (productID === null) {
            //     displayMessageAndChangeIcon(data, btn, shouldAdd);
            // }
            if ($('.size-available').attr('available') != 'false') {
                displayMessageAndChangeIcon(data, btn, shouldAdd);
            }

            $('body').trigger('wishlist:changedSuccessfully', {
                data: data,
                isAdding: shouldAdd,
                pid: pid
            });
            var $productContainer = $(e.currentTarget).closest('.product-detail');

            if (!$productContainer.length) {
                $productContainer = $(e.currentTarget).closest('.quickview-modal').find('.product-detail');
            }

            if (!$productContainer.length) {
                $productContainer = $('.quickview-modal').find('.product-detail');
            }

            if (!$productContainer.length) {
                $productContainer = $('.product-detail');
            }
            if (shouldAdd) {
                $('body').trigger('product:afterAddToWishlist', { ...data, $productContainer });
            } else {
                $('body').trigger('product:afterRemoveFromWishlist');
            }
            $('body').trigger('wishlist:update', data.wishlistTotal);
            if (!$('.cc-sizeBox-isOpen').length && !$('.js-addToCartWrapper').hasClass('hidden')) {
                sizePanel.switchButtonsSticky();
                sizePanel.switchButtons();
            }
            $.spinner().stop();
        },
        error: function (err) {
            $.spinner().stop();
            $('body').trigger('product:failedAddToWishlist');
            displayMessageAndChangeIcon(err, btn, shouldAdd);
        }
    });
}

function updateAriaLabelForWishlistLink (product) {
    var added = $(product).hasClass('added');
    var labelAddWishlist = product.data('label-add-wishlist');
    var labelRemoveWishlist = product.data('label-remove-wishlist');
    if (added) {
        product.attr('aria-label', labelRemoveWishlist);
    } else {
        product.attr('aria-label', labelAddWishlist);
    }
}

module.exports = {
    handleWishlistContainer: function (item) {
        if (module.exports.checkItemInWishlist(item)) {
            $('.wishlist-icon').addClass('added');
            $('.wishlist-icon').find('use').attr('href', $('.wishlist-icon').data('full-heart'));
        } else {
            $('.wishlist-icon').removeClass('added');
            $('.wishlist-icon').find('use').attr('href', $('.wishlist-icon').data('empty-heart'));
        }
        updateAriaLabelForWishlistLink($('.wishlist-icon'));
    },

    checkItemInWishlist: function (itemCode) {
        return $('#wishlistItems').length > 0 && $('#wishlistItems').val().split(',').indexOf(itemCode) > -1;
    },

    /**
     * Add the `added' class to the wishlist icon if the item is available in the wishlist.
     * It is not possible to do it in ISML because both the PDP and the PLP are cached
     *
     * Read the DOM element `#wishlistItems` and adds the `added` class to all the
     * `plp-wishlist` or `add-to-wish-list` items available in>
     *  - quickview
     *  - PDP
     *  - PLP
     */
    highlightIconsForAllItemsInWishlist: function () {
        if (!$('#wishlistItems').length) {
            return;
        }

        var itemsInWishlist = $('#wishlistItems').val().split(',');
        for (var i = 0; i < itemsInWishlist.length; i++) {
            var itemCode = itemsInWishlist[i];

            let plpWishlist = $(`.product[data-pid="${itemCode}"] .plp-wishlist`);
            let productDetailWishlist = $(`.product-detail[data-pid="${itemCode}"] .add-to-wish-list`);

            plpWishlist.addClass('added');
            updateAriaLabelForWishlistLink(plpWishlist);
            plpWishlist.find('use').attr('xlink:href', plpWishlist.data('full-heart'));
            plpWishlist.blur();

            productDetailWishlist.addClass('added');
            updateAriaLabelForWishlistLink(productDetailWishlist);
            productDetailWishlist.find('use').attr('xlink:href', productDetailWishlist.data('full-heart'));
            productDetailWishlist.blur();
        }
    },

    moveToWishlistHelper: function (e) {
        if (!e) {
            return;
        }
        e.preventDefault();

        var $btn = $(e.currentTarget);
        var url = $btn.data('href');
        var pid = $btn.data('pid');

        $.spinner().start();
        return $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                pid: pid,
                optionId: null,
                optionVal: null
            },
            success: function (data) {
                displayMessageAndChangeIcon(data, null);
            },
            error: function (err) {
                displayMessageAndChangeIcon(err, null);
            }
        });
    },


    moveToWishlistHelperSaveForLater: function (e) {
        if (!e) {
            return;
        }
        e.preventDefault();

        var $btn = $(e.currentTarget);
        var url = $btn.data('href');
        var pid = $btn.data('pid');

        $.spinner().start();
        return $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                pid: pid,
                optionId: null,
                optionVal: null
            },
            success: function (data) {
                //displayMessageAndChangeIcon(data, null);
            },
            error: function (err) {
                displayMessageAndChangeIcon(err, null);
            }
        });
    },

    /**
     * Adds the current item referenced by the current target to the wishlist
     * and updates the front-end
     */
    addToWishlist () {
        $('body').on('click', '.add-to-wish-list', (e) => {
            e.preventDefault();
            let target = $(e.currentTarget);
            // Simulate disabled button with class to allow click and event
            if (($(e.currentTarget).hasClass('add-to-wish-list-quickview-mobile') && !isSizeSelected()) || ($(e.currentTarget).hasClass('wishlistButtMobile') && !$('.pdp-buy-look-container').hasClass('hidden'))) {
                return;
            } else if (!isSizeSelected()) {
                // If no size is selected, open modal to choose one
                if (target.closest('.product-quickview').length) {
                    this.sizeModal = newModalFromSelector('fis-select-size-wishlist', false, ['js-prod-select-size-modal']);
                    const triggerElement = document.activeElement;
                    this.sizeModal.open();

                    setTimeout(() => {
                        $(this.sizeModal.modalBox).find('.size-selector:visible').first().focus();
                    }, 100);
                    $(this.sizeModal.modalBox).find('.add-to-wish-list-confirm').attr('disabled', true);

                    $(this.sizeModal.modalBox)
                        .on('click', '.modal__closeIcon', (e) => {
                            this.sizeModal.close();
                            this.sizeModal.destroy();
                            if (triggerElement) {
                                $(triggerElement).focus();
                            }
                        })
                        .on('click', '.size-selector', (e) => {
                            const $clickedButton = $(e.currentTarget);
                            const sizeValue = $clickedButton.data('size-fixed');
                            $clickedButton.closest('ul').find('button').not(e.currentTarget).removeClass('selected');
                            $clickedButton.addClass('selected');

                            const $inputToClick = $('[data-attr="size"] input').filter(`[data-size-fixed="${sizeValue}"]`);

                            if ($clickedButton.data('attr-selectable') === 'selectable' && $inputToClick.prop('disabled') === false) {
                                // Select size in PDP by passing click to attribute selector click only if selectable
                                $inputToClick.trigger('click');
                                $(this.sizeModal.modalBox).find('.add-to-wish-list-confirm').prop('disabled', false);
                                $('.size-available').attr('available', true);
                            } else {
                                // Only if the size is not available
                                let infoURL = $clickedButton.data('attr-info-url');
                                if ($('.product-quickview').length > 0) {
                                    $('.product-quickview').find('.wishlist-icon').removeClass('added');
                                    $('.product-quickview').find('.wishlist-icon').find('use').attr('xlink:href', $('.wishlist-icon').data('empty-heart'));
                                }
                                var _self = this;
                                $.spinner().start();
                                $.ajax({
                                    url: infoURL,
                                    type: 'get',
                                    dataType: 'json',
                                    success: function (data) {
                                        $(_self.sizeModal.modalBox)
                                            .find('.add-to-wish-list-confirm')
                                            .prop('disabled', !data.product.readyToOrder);
                                        $('.product-detail-keeper').attr('data-variant-pid', encodeURIComponent(data.product.id));
                                        $('.product-detail').data('pid', data.product.id);
                                        $('.size-available').attr('available', false);
                                        $.spinner().stop();
                                    },
                                    error: function () {
                                        $.spinner().stop();
                                    }
                                });
                            }
                        });

                    $(this.sizeModal.modalBox).on('click', '.add-to-wish-list-confirm', (e) => {
                        // Add to wishlist definitely
                        let pid = null;
                        if ($('.product-detail')) {
                            pid = $('.product-detail').data('pid');
                        } else if ($('.product-quickview')) {
                            pid = $('.product-quickview').data('pid');
                        }
                        addDefinitelyToWishlist(target, pid, e);
                    });

                    $('body').on('product:afterAddToWishlist', (e) => {
                        if (this.sizeModal.modal) {
                            this.sizeModal.close();
                            this.sizeModal.destroy();
                            if (triggerElement) {
                                $(triggerElement).focus();
                            }
                        }
                    });

                    $('body').on('product:failedAddToWishlist', (e) => {
                        if (this.sizeModal.modal) {
                            this.sizeModal.close();
                            this.sizeModal.destroy();
                            if (triggerElement) {
                                $(triggerElement).focus();
                            }
                        }
                    });
                } else {
                    sizePanel.openSizePanel(sizePanel.Types.WISHILIST);
                    $('.pdp-size-box .js-sizeBox-openPanel').addClass('cc-sizeBox-openPanel_error');
                }
                return;
            }
            addDefinitelyToWishlist(target, null, e);
        });

        $('body').on('wishlist:add-pid', (_, d) => {
            const target = $('.add-to-wish-list').eq(0);
            addDefinitelyToWishlist(target, d.pid, {currentTarget: target});
        });
    }
};
